import { createContext, useContext } from "react";

type SidebarRefreshContextValue = {
    refreshSidebar: () => Promise<unknown>;
};

export const SidebarRefreshContext = createContext<SidebarRefreshContextValue | null>(null);

export function useSidebarRefresh() {
    return useContext(SidebarRefreshContext);
}
